var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTempleMessages(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9997 3.02075C6.31676 3.02075 2.52051 6.817 2.52051 11.4999V19.9791H10.9997C15.6826 19.9791 19.4788 16.1828 19.4788 11.4999C19.4788 6.817 15.6826 3.02075 10.9997 3.02075ZM1.83301 20.6666L1.14551 20.6665V11.4999C1.14551 6.05761 5.55737 1.64575 10.9997 1.64575C16.442 1.64575 20.8538 6.05761 20.8538 11.4999C20.8538 16.9422 16.442 21.3541 10.9997 21.3541H1.83308L1.83301 20.6666ZM1.83301 20.6666L1.83308 21.3541C1.45339 21.3541 1.14551 21.0462 1.14551 20.6665L1.83301 20.6666Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72949 8.75C5.72949 8.3703 6.0373 8.0625 6.41699 8.0625H14.667C15.0467 8.0625 15.3545 8.3703 15.3545 8.75C15.3545 9.1297 15.0467 9.4375 14.667 9.4375H6.41699C6.0373 9.4375 5.72949 9.1297 5.72949 8.75Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72949 12.4167C5.72949 12.0371 6.0373 11.7292 6.41699 11.7292H14.667C15.0467 11.7292 15.3545 12.0371 15.3545 12.4167C15.3545 12.7964 15.0467 13.1042 14.667 13.1042H6.41699C6.0373 13.1042 5.72949 12.7964 5.72949 12.4167Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72949 16.0833C5.72949 15.7036 6.0373 15.3958 6.41699 15.3958H11.0003C11.38 15.3958 11.6878 15.7036 11.6878 16.0833C11.6878 16.4629 11.38 16.7708 11.0003 16.7708H6.41699C6.0373 16.7708 5.72949 16.4629 5.72949 16.0833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTempleMessages);
export default __webpack_public_path__ + "static/media/temple-messages.6dd8c77d3cb19130dcd1e93000f9a46b.svg";
export { ForwardRef as ReactComponent };